import { useRouter } from 'next/router'
import { useCallback } from 'react'

import { getEventInvoiceLocalStorageId } from '../utils/getEventInvoiceLocalStorageId'
import { useSsrLocalStorage } from './useLocalStorage'
import { useOrigin } from './useOrigin'
import { useXendit } from './useXendit'

export function useCreateInvoice(params: { eventId: number; groupId: number }) {
  const { createInvoice: createInvoiceGateway } = useXendit()
  // const [, setInvoiceId] = useSsrLocalStorage(
  //   getEventInvoiceLocalStorageId(params.eventId),
  //   '',
  // )
  const router = useRouter()
  const origin = useOrigin()

  const createInvoice = useCallback(() => {
    return createInvoiceGateway(params, {
      failure_redirect_url: `${origin}/xendit/failure?redirect=${router.asPath}&event_id=${params.eventId}`,
      success_redirect_url: `${origin}/xendit/success?redirect=${router.asPath}&event_id=${params.eventId}`,
    }).then((invoice: any) => {
      // setInvoiceId(invoice.data.external_id)
      return invoice
    })
  }, [createInvoiceGateway, origin, params, router.asPath])
  return createInvoice
}
